<template>
  <div class="contact-container">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-background">
        <img :src="Images.contact.background" alt="Background" class="hero-bg-image">
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <h1 class="hero-title">联系我们</h1>
        <div class="hero-subtitle">
          <img :src="Images.contact.to_left" alt="Left dash" class="subtitle-dash">
          <span>CONTACT US</span>
          <img :src="Images.contact.to_right" alt="Right dash" class="subtitle-dash">
        </div>
      </div>
    </section>
    
    <main class="contact-content">
      <!-- 面包屑导航 -->
      <section class="breadcrumb-section">
        <div class="container">
          <nav class="breadcrumb">
            <router-link to="/home" class="breadcrumb-item">首页</router-link>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item active">联系我们</span>
          </nav>
        </div>
      </section>
      
      <!-- 联系表单和联系方式 -->
      <section class="contact-section">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">联系我们</h3>
            <p class="subtitle">如果您对我们的产品和服务有任何疑问，或者想了解更多信息，请随时与我们联系</p>
          </div>
          <div class="contact-content-wrapper">
            <div class="contact-form">
              <h4 class="form-title">发送消息</h4>
              <form>
                <div class="form-row">
                  <div class="form-group">
                    <label for="name">姓名 *</label>
                    <input type="text" id="name" name="name" placeholder="请输入您的姓名" required>
                  </div>
                  <div class="form-group">
                    <label for="email">邮箱 *</label>
                    <input type="email" id="email" name="email" placeholder="请输入您的邮箱" required>
                  </div>
                </div>
                <div class="form-group">
                  <label for="phone">电话</label>
                  <input type="tel" id="phone" name="phone" placeholder="请输入您的电话">
                </div>
                <div class="form-group">
                  <label for="subject">主题 *</label>
                  <select id="subject" name="subject" required>
                    <option value="">请输入咨询主题</option>
                    <option value="product">产品咨询</option>
                    <option value="service">服务咨询</option>
                    <option value="cooperation">合作洽谈</option>
                    <option value="other">技术咨询</option>
                    <option value="other">技术支持</option>
                    <option value="other">其他</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="message">消息内容 *</label>
                  <textarea id="message" name="message" rows="5" placeholder="请输入您的消息内容" required></textarea>
                </div>
                <div class="form-group">
                  <label for="attachment">附件</label>
                  <div class="attachment-upload">
                    <input type="file" id="attachment" name="attachment" class="file-input">
                    <label for="attachment" class="file-label">选择文件</label>
                    <span class="file-name">未选择任何文件</span>
                  </div>
                  <p class="attachment-hint">支持上传PDF、Word、Excel、图片等格式，最大文件大小10MB</p>
                </div>
                <button type="submit" class="submit-btn">提交</button>
              </form>
            </div>
            <div class="contact-info">
              <h4 class="info-title">联系方式</h4>
              <div class="contact-details">
                <div class="contact-item">
                  <div class="contact-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#ff6b00">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                  </div>
                  <div class="contact-text">
                    <p class="contact-value">深圳市龙华区大浪街道浪口社区华霆路387号5栋2层</p>
                  </div>
                </div>
                <div class="contact-item">
                  <div class="contact-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#ff6b00">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                  </div>
                  <div class="contact-text">
                    <p class="contact-value">0755-21004378</p>
                  </div>
                </div>
                <div class="contact-item">
                  <div class="contact-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#ff6b00">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                  </div>
                  <div class="contact-text">
                    <p class="contact-value">1607845075@qq.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 公司位置 -->
      <section class="company-location">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">公司位置</h3>
            <p class="subtitle">欢迎您随时来访</p>
          </div>
          <div class="location-map">
            <img :src="Images.contact.address" alt="公司位置地图">
          </div>
        </div>
      </section>
      
      <!-- 常见问题 -->
      <section class="faq-section">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">常见问题</h3>
            <p class="subtitle">以下是客户经常咨询的问题，如果您有其他疑问，请随时联系我们</p>
          </div>
          <div class="faq-list">
            <div class="faq-item">
              <div class="faq-header">
                <h4 class="faq-question">如何获取产品演示？</h4>
                <span class="faq-toggle">▼</span>
              </div>
              <div class="faq-content">
                <p>您可以通过以下方式获取产品演示：1. 填写网站上的"联系我们"表单，选择"产品咨询"主题；2. 拨打我们的热线电话 0755-21004378；3. 发送邮件至 1607845075@qq.com。我们将在工作日内与您联系，安排产品演示。</p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-header">
                <h4 class="faq-question">贵公司提供哪些技术支持服务？</h4>
                <span class="faq-toggle">▼</span>
              </div>
              <div class="faq-content">
                <p>我们提供全方位的技术支持服务，包括：24小时电话技术支持；2. 在线技术支持工单系统；3. 定期的系统维护和升级；4. 专业的技术培训；5. 定制化的技术解决方案。我们的技术支持团队由经验丰富的工程师组成，能够快速响应和解决客户的技术问题。</p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-header">
                <h4 class="faq-question">如何成为贵公司的合作伙伴？</h4>
                <span class="faq-toggle">▼</span>
              </div>
              <div class="faq-content">
                <p>我们欢迎各类有实力的企业成为我们的合作伙伴。如果您有合作意向，可以通过以下方式联系我们：1. 填写网站上的"联系我们"表单，选择"合作洽谈"主题；2. 发送邮件至 partnership@futuretech.com。我们的合作伙伴团队会评估您的合作提案，并在工作日内与您联系。</p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-header">
                <h4 class="faq-question">贵公司的产品是否支持定制化开发？</h4>
                <span class="faq-toggle">▼</span>
              </div>
              <div class="faq-content">
                <p>是的，我们支持定制化开发。我们拥有专业的研发团队，可以根据客户的具体需求，提供定制化的解决方案。定制化开发包括功能定制、界面定制、集成开发等。如果您有定制化需求，请联系我们，我们会为您提供详细的定制化方案和报价。</p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-header">
                <h4 class="faq-question">贵公司的产品价格是多少？</h4>
                <span class="faq-toggle">▼</span>
              </div>
              <div class="faq-content">
                <p>我们的产品价格根据不同的产品类型、配置、用户数量等因素有所不同。我们提供灵活的定价模式，包括永久授权、订阅制、按需付费等。如果您想了解具体的产品价格，请联系我们，我们会根据您的具体需求，为您提供详细的报价方案。</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'ContactView',
  data() {
    return {
      Images
    }
  },
  mounted() {
    // FAQ 折叠面板交互 - 将查询范围限制在当前组件内部
    const faqItems = this.$el.querySelectorAll('.faq-item');
    
    if (faqItems.length > 0) {
      faqItems.forEach(item => {
        const header = item.querySelector('.faq-header');
        
        if (header) {
          header.addEventListener('click', () => {
            const isActive = item.classList.contains('active');
            
            // 关闭所有其他FAQ
            faqItems.forEach(faq => {
              faq.classList.remove('active');
            });
            
            // 切换当前FAQ的状态
            if (!isActive) {
              item.classList.add('active');
            }
          });
        }
      });
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero {
  position: relative;
  height: 72.5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 80px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

.hero-content {
  text-align: center;
  color: white;
  z-index: 1;
  max-width: 1000px;
  padding: 0 80px;
  margin: 0 auto;
}

.hero-title {
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
  color: #FFFFFF;
}

.subtitle-dash {
  width: 60px;
  height: auto;
  margin: 0 10px;
}

/* Breadcrumb Section */
.breadcrumb-section {
  padding: 20px 0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-item:hover {
  color: #ff6b00;
}


.breadcrumb-separator {
  margin: 0 10px;
  color: #999;
}

/* Section Title */
.section-title {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.section-title .main-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-title .main-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #ff6b00;
  border-radius: 1.5px;
}

.section-title .subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* Contact Section */
.contact-section {
  padding: 80px 0;
  background-color: #fff;
}

.contact-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 60px;
  margin-top: 60px;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.contact-form {
  background-color: #fff;
  border-right: 1px solid #f0f0f0;
  padding: 0;
}

.form-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  transition: border-color 0.3s ease;
  width: 100%;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #ff6b00;
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.captcha {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 20px;
}

.captcha-image {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background-color: #f8f8fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.captcha-image img {
  max-width: 120px;
  height: auto;
}

.captcha-refresh {
  font-size: 12px;
  color: #ff6b00;
  cursor: pointer;
  text-decoration: underline;
}

.submit-btn {
  width: 100%;
  padding: 14px 20px;
  background-color: #ff6b00;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 20px;
}

.submit-btn:hover {
  background-color: #e55c00;
}

/* Contact Info */
.contact-info {
  background-color: #fff;
  padding: 0;
}

.info-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contact-icon {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #ff6b00;
}

.contact-icon svg {
  width: 24px;
  height: 24px;
  fill: #ff6b00;
}

.contact-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact-value {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 1.6;
}

/* Company Location */
.company-location {
  padding: 80px 0;
  background-color: #f8f8fa;
}

.location-map {
  margin-top: 60px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.location-map img {
  width: 100%;
  height: auto;
  display: block;
}

/* Attachment Upload */
.attachment-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.file-input {
  display: none;
}

.file-label {
  padding: 8px 16px;
  background-color: #f0f0f0;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.file-label:hover {
  background-color: #e0e0e0;
}

.file-name {
  font-size: 14px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.attachment-hint {
  font-size: 12px;
  color: #999;
  margin: 0;
}

/* FAQ Section */
.faq-section {
  padding: 80px 0;
  background-color: #fff;
}

.faq-list {
  margin-top: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.faq-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: none;
  transition: all 0.3s ease;
}

.faq-header:hover {
  color: #ff6b00;
}

.faq-question {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.faq-toggle {
  font-size: 16px;
  color: #999;
  transition: transform 0.3s ease;
}

.faq-content {
  padding: 0 30px;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-content p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0;
}

.faq-item.active .faq-toggle {
  transform: rotate(180deg);
  color: #999;
}

.faq-item.active .faq-content {
  max-height: 200px;
  padding: 20px 30px;
  background-color: #fafafa;
}
.breadcrumb-item.active {
  color: #333;
  font-weight: 500;
}
/* Responsive Design */
@media (max-width: 768px) {
  /* Hero Section */
  .hero-title {
    font-size: 36px;
  }
  
  /* Contact Section */
  .contact-section {
    padding: 60px 0;
  }
  
  .contact-content-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
    margin-top: 40px;
  }
  
  .contact-form {
    padding: 30px 20px;
  }
  
  .contact-info {
    padding: 30px 20px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .captcha {
    grid-template-columns: 1fr;
  }
  
  /* Company Location */
  .company-location {
    padding: 60px 0;
  }
  
  .location-map {
    margin-top: 40px;
  }
  
  /* FAQ Section */
  .faq-section {
    padding: 60px 0;
  }
  
  .faq-list {
    margin-top: 40px;
  }
}

@media (max-width: 480px) {
  /* Hero Section */
  .hero {
    height: 200px;
  }
  
  .hero-title {
    font-size: 28px;
  }
  
  .hero-subtitle {
    font-size: 14px;
  }
  
  /* Contact Section */
  .contact-form {
    padding: 20px;
  }
  
  .form-title {
    font-size: 18px;
  }
  
  .contact-info {
    padding: 20px;
  }
  
  .info-title {
    font-size: 18px;
  }
  
  /* FAQ Section */
  .faq-question {
    font-size: 15px;
  }
}
</style>